import React from 'react';

type ButtonProps = {
  visible: boolean;
  disabled?: boolean;
  text: string;
  onClick: () => void;
};

const PrimaryButton = ({ visible, disabled, text, onClick }: ButtonProps) => {
  return (
    <>
      {visible && (
        <button className="btn thule-btn-default w-100" onClick={onClick} disabled={disabled}>
          {text}
        </button>
      )}
    </>
  );
};

export default PrimaryButton;
